import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import FilePatternForm from './FilePatternForm'
import { Paper, withStyles, Dialog, CircularProgress } from "@material-ui/core";
import { BackButton, hasPermission } from '../../sc-utilities';
import { parseURL } from "../../sc-utilities";
import { connect } from "react-redux";
import * as actions from "./store/filePatternActions";
import History from "../../../History";
import AppLogoLoading from '../../sc-logo';
import {updateKey} from "../TypicalProblem/TypicalProblemForm";

const styles = theme => ({
  root: {
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(2),
    paddingRight: theme.spacing(6),
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
      paddingRight: 0,
    }
  },
  submit: {
    backgroundColor: "transparent",
    boxShadow: "none",
    overflow: "hidden",
    alignItems: "center"
  },
  cancel: {
    width: "250px",
    margin: "10px"
  }
});

const FilePatternEdit = props => {
  const { filePattern, classes, onFetchFilePatternInit, onFetchFilePattern, activeCustomer, onEditFilePattern, translations, permissions } = props;
  const [data, setData] = useState(true);

  const handleSubmit = async data => {
    let objestToSend = {...data};
    objestToSend['FilePatternID'] = filePattern.FilePatternID;
    if (objestToSend["Key"] === "" || objestToSend["CustomerID"] === 'custom') {
      objestToSend["Key"] = null;
    }
    objestToSend["CustomerID"] === "system" ? objestToSend["CustomerID"] = null    :   objestToSend["CustomerID"] = activeCustomer;
    let result = await onEditFilePattern({ ...objestToSend, ActiveCustomerID: activeCustomer });
    if (result) {
      History.goBack()
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      await onFetchFilePattern({ ActiveCustomerID: activeCustomer, FilePatternID: parseURL(window.location.href).filePatternID })
      setData(false)
    }
    fetchData();
    return () => {
      onFetchFilePatternInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let initialValues = {
    Name: filePattern.Name || "",
    Pattern: filePattern.Pattern || "",
    CustomerID: filePattern?.CustomerID ? "custom"   :   "system",
    Key: filePattern?.Key ? filePattern.Key : filePattern.Name && filePattern?.CustomerID ? updateKey(filePattern.Name) : '',
  };

  let formSettings = {
    Validation: {
      Name: Yup.string().required("Required"),
      Pattern: Yup.string().required("Required"),
      CustomerID: Yup.string().required("Required"),
      Key: Yup.string().required("Required"),
    },
    FormTitle: translations['edit_file_pattern'] || 'Edit file pattern',
    ButtonSubmit: hasPermission(permissions, "system_file_pattern_save") || (hasPermission(permissions, "file_pattern_save") && filePattern.CustomerID)
      ? {
        Title: translations["save"] || "SAVE",
        Color: 'primary'
      }
      : null
  };

  return (
    <Paper className={classes.root} >
      {BackButton(translations)}
      <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data}
        PaperProps={{
          classes: {
            root: classes.submit
          }
        }} >

        <AppLogoLoading />
      </Dialog>
      {!data ?
        <FilePatternForm
          formSettings={formSettings}
          initialValues={initialValues}
          handleSubmit={handleSubmit}
          translations={translations}
          permissions={permissions}
          CustomerIDPreviousState={filePattern?.CustomerID ? 'custom'   :   'system'}
          fromEdit={true}
        />
        : <CircularProgress
          variant="determinate"
          color="primary"
          size={28}
        />}
    </Paper>)
}

const mapStateToProps = state => {
  return {
    activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
    permissions: state?.core?.login?.permissions || [],
    filePattern: state.setting.filePatterns && state.setting.filePatterns.loaded ? state.setting.filePatterns.loaded : {},
    translations:
      state.translate && state.translate.translations
        ? state.translate.translations.activeTranslations || {}
        : {},
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchFilePatternInit: filePattern => dispatch(actions.loadFilePatternInit(filePattern)),
    onFetchFilePattern: filePattern => dispatch(actions.loadFilePattern(filePattern)),
    onEditFilePattern: filePattern => dispatch(actions.editFilePattern(filePattern)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(FilePatternEdit));